<script lang="ts" setup>
    import { useDownloadsStore, type DownloadEntry } from '~~/stores/downloads'

    const downloadsStore = useDownloadsStore()

    function downloadFile(entry: DownloadEntry): void {
        const anchor = document.createElement('a')
        anchor.href = `/api/me/downloads/${entry.downloadKey}`
        anchor.click()
    }

    function formatExpiry(expiresAt: number): string {
        const remainingMs = expiresAt - Date.now()
        const minutes = Math.ceil(remainingMs / 60_000)
        if (minutes <= 0) { return 'expiring soon' }
        if (minutes < 60) { return `${minutes}m` }
        return `${Math.ceil(minutes / 60)}h`
    }
</script>

<template>
    <q-list dense>
        <q-item
            v-for="entry in downloadsStore.downloads"
            :key="entry.downloadKey"
        >
            <q-item-section>
                <q-item-label class="text-caption">
                    {{ entry.filename }}
                </q-item-label>
                <q-item-label caption>
                    expires in {{ formatExpiry(entry.expiresAt) }}
                </q-item-label>
            </q-item-section>
            <q-item-section side>
                <q-btn
                    flat
                    dense
                    size="sm"
                    icon="download"
                    label="Download"
                    @click="downloadFile(entry)"
                />
            </q-item-section>
        </q-item>
    </q-list>
</template>
